import { AuthClient } from 'oat-common-ui';

const skip = process.env.REACT_APP_AZURE_AUTH === 'skip';
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID as string;
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID as string;
const authClient = new AuthClient(clientId, tenantId, skip);

export default authClient;
